import api from "./fusionSolarApi";

// ✅ Typ pojedynczej stacji
export type Station = {
  plantName: string;
  plantCode: string;
  capacity: number;
};

// 🧠 Cache'y lokalne (w module)
let cachedStations: Station[] | undefined;
let cachedPlantDetails: Record<string, any> = {};
let cachedHistory: Record<string, any> = {};

// ✅ Pobierz listę stacji (z cache i automatycznym tokenem)
export const getStationList = async (): Promise<Station[]> => {
  if (cachedStations) return cachedStations;
  const res = await api.get("stations");
  console.log('res fusionsolar', res)
  cachedStations = res.data.data.list || [];
  return cachedStations ?? [];
};

// ✅ Pobierz szczegóły stacji (z cache)
export const getPlantDetails = async (plantCode: string) => {
  if (cachedPlantDetails[plantCode]) return cachedPlantDetails[plantCode];
  const res = await api.get("stationDetails", { params: { plantCode } });
  cachedPlantDetails[plantCode] = res.data.data;
  return cachedPlantDetails[plantCode];
};

// ✅ Pobierz dane historyczne
export const getHistoryData = async (plantCode: string) => {
  if (cachedHistory[plantCode]) return cachedHistory[plantCode];
  const res = await api.get("historical", { params: { plantCode } });
  cachedHistory[plantCode] = res.data;
  return cachedHistory[plantCode];
};

// ❌ Wyczyszczenie cache (na żądanie)
export const clearHuaweiCache = () => {
  cachedStations = undefined;
  cachedPlantDetails = {};
  cachedHistory = {};
};

export const getStationDailyData = async (plantCode: string) => {
  const res = await api.get("stationDaily", {
    params: {
      plantCode,
      currentTime: Date.now(), // <--- dynamiczna data
    },
  });

  if (!res.data || !res.data.data) {
    throw new Error("Brak danych dziennych lub błędna odpowiedź");
  }

  return res.data.data;
};

export const getMonthlyKpi = async (plantCode: string) => {
  const res = await api.get("stationMonthly", {
    params: { plantCode },
  });
  return res.data.data;
};
